export class RfqSessionNudgeSettingType {
	public id: number;
	public name: string;

	constructor(rfqSessionNudgeSettingType?: RfqSessionNudgeSettingType) {
		Object.assign(this, rfqSessionNudgeSettingType);
	}
}
